(() => {
  'use strict';
  if (customElements.get('fg-r2-guidance')) return;
  class FuguiGuidance extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.info = this.closest('product-info');
      this.dialog = this.querySelector('[data-fg-r2-dialog]');
      const source = this.querySelector('[data-fg-r2-config]');
      try { this.config = JSON.parse(source.textContent); } catch { return; }
      this.onClick = event => {
        const close = event.target.closest('[data-fg-r2-close]');
        if (close && this.contains(close)) this.dialog.close();
        const button = event.target.closest('[data-fg-r2-open]');
        if (!button || !this.info.contains(button) || button.disabled || button.hidden) return;
        const slug = button.dataset.fgR2Open === 'stone' ? this.stoneGuide() : button.dataset.fgR2Open;
        if (slug && this.eligible(slug)) this.open(slug, button);
      };
      this.info.addEventListener('click', this.onClick);
      this.onBackdrop = event => { if (event.target === this.dialog) this.dialog.close(); };
      this.dialog.addEventListener('click', this.onBackdrop);
      this.onClose = () => { if (this.opener?.isConnected) this.opener.focus(); };
      this.dialog.addEventListener('close', this.onClose);
      this.onUnavailable = () => this.setPending();
      this.info.addEventListener('fugui:variant-unavailable', this.onUnavailable);
      this.info.addEventListener('fugui:variant-fetch-error', this.onUnavailable);
      this.unsubscribers = [];
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
          if (data?.event?.target && this.info.contains(data.event.target)) this.setPending();
        }));
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data?.sectionId) !== String(this.dataset.section)) return;
          const variantId = String(data.variant?.id || '');
          const liveVariant = this.info.querySelector('product-form input[name="id"]')?.value;
          if (!variantId || variantId !== String(liveVariant)) return;
          this.update(variantId);
        }));
      }
      this.observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting && !entry.target.hidden) this.loadFigure(entry.target); });
      }, { rootMargin: '100px' }) : null;
      this.info.querySelectorAll('[data-fg-r2-figure]').forEach(figure => this.observer?.observe(figure));
      this.update(String(this.config.variantId || ''));
    }
    disconnectedCallback() {
      this.info?.removeEventListener('click', this.onClick);
      this.info?.removeEventListener('fugui:variant-unavailable', this.onUnavailable);
      this.info?.removeEventListener('fugui:variant-fetch-error', this.onUnavailable);
      this.dialog?.removeEventListener('click', this.onBackdrop);
      this.dialog?.removeEventListener('close', this.onClose);
      this.unsubscribers?.forEach(unsubscribe => unsubscribe());
      this.observer?.disconnect();
      this.initialized = false;
    }
    eligible(slug) {
      return !this.pending && this.config.guides[slug]?.variantIds.includes(this.variantId);
    }
    stoneGuide() {
      return Object.keys(this.config.guides).find(slug => slug.startsWith('stone-') && this.eligible(slug));
    }
    setPending() {
      this.pending = true;
      if (this.dialog.open) this.dialog.close();
      this.sync();
    }
    update(variantId) {
      this.variantId = String(variantId);
      this.pending = false;
      this.sync();
    }
    sync() {
      this.info.querySelectorAll('[data-fg-r2-open]').forEach(button => {
        const slug = button.dataset.fgR2Open === 'stone' ? this.stoneGuide() : button.dataset.fgR2Open;
        button.hidden = !slug || !this.eligible(slug);
        button.disabled = this.pending || !slug || !this.eligible(slug);
      });
      this.info.querySelectorAll('[data-fg-r2-figure]').forEach(figure => {
        figure.hidden = !this.eligible(figure.dataset.fgR2Figure);
        if (!figure.hidden && !this.observer) this.loadFigure(figure);
        if (!figure.hidden && this.observer) {
          this.observer.unobserve(figure);
          this.observer.observe(figure);
        }
      });
    }
    loadFigure(figure) {
      const image = figure.querySelector('[data-fg-r2-image]');
      if (!image || image.hasAttribute('src') || figure.hidden) return;
      image.srcset = image.dataset.srcset;
      image.src = image.dataset.src;
      this.observer?.unobserve(figure);
    }
    open(slug, button) {
      const guide = this.config.guides[slug];
      const body = this.querySelector('[data-fg-r2-dialog-body]');
      const copy = this.querySelector(`template[data-fg-r2-template="${slug}"]`);
      if (!copy || !guide) return;
      if (slug.startsWith('stone-')) {
        body.replaceChildren(copy.content.cloneNode(true));
      } else {
        const image = document.createElement('img');
        image.width = guide.width;
        image.height = guide.height;
        image.alt = guide.alt;
        image.decoding = 'async';
        image.sizes = '(min-width: 900px) 800px, calc(100vw - 20px)';
        image.srcset = `${guide.web600} 600w, ${guide.web900} 900w`;
        image.src = guide.web900;
        body.replaceChildren(image, copy.content.cloneNode(true));
      }
      this.querySelector('[data-fg-r2-title]').textContent = guide.title;
      this.opener = button;
      this.dialog.showModal();
    }
  }
  customElements.define('fg-r2-guidance', FuguiGuidance);
})();
